import { Controller } from "react-hook-form"
import { FormControl, FormLabel } from "@fedsim/components"
import React from "react"

const height = "56px"
const width = "100px"

const style = { height, width }

export const FormColor = ({ name, control, label }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => {
        return (
          <FormControl fullWidth>
            <FormLabel htmlFor={name}>{label}</FormLabel>
            <input
              type='color'
              id={name}
              onChange={onChange}
              name={name}
              value={value}
              style={style}
            />
          </FormControl>
        )
      }}
    />
  )
}
